<template>
  <div>
    <div v-for="gallery in galleries" :key="gallery.id">
      <Gallery :gallery-type="galleryType" :gallery="gallery" />
    </div>
    <ModalCurrencyMismatch />
  </div>
</template>

<script>
import Gallery from "@/domain/galleries/Gallery.vue";
import ModalCurrencyMismatch from "@/domain/galleries/modals/ModalCurrencyMismatch.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'PaidGalleries',
  components: {ModalCurrencyMismatch, Gallery},
  props: {
    galleries: {
      type: Array,
      required: true
    },
    galleryType: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('cartDigitalItems', ['cartDigitalItems']),
  },
  async mounted() {
    await this.fetchDigitalItems()
  },
  methods: {
    ...mapActions('cartDigitalItems', ['fetchDigitalItems']),
  },
}
</script>
